import { Title } from "@angular/platform-browser";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@app/_services";
import { interval, Subscription } from "rxjs";
import { MastersuiteService } from "../mastersuite.service";
import { ToastrService } from "ngx-toastr";
import { TestCaseService } from "@app/testcase/testcase.service";
import { TestsuiteService } from "@app/testsuite/testsuite.service";

@Component({
  selector: "app-result",
  templateUrl: "./result.component.html",
  styleUrls: ["./result.component.less"],
})
export class ResultComponent implements OnInit, OnDestroy {
  pramsId: number;
  mastersuiteDetails: any;
  recentExecution: any;
  autoExecuteCounter: Subscription;
  isAutoRefresh: boolean;
  autoRefreshInterval = 5;
  currentPage = 0;
  perPageData = 15;
  testSuiteExecDetails: any;
  activeIndex: string;
  showTestsuiteResult: boolean;
  autoRefreshCounter: any;
  resultTsuiteExec: any;
  activeindexTC: any = null;
  testCaseExecResult: any;
  closeErrorAlert = false;
  warningFlag = true;
  parallelRun: boolean;
  projectConfiguration:any;


  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private AuthService: AuthenticationService,
    private MasterSuiteService: MastersuiteService,
    private Tostr: ToastrService,
    private TestcaseService: TestCaseService,
    private TestSuiteService: TestsuiteService
  ) {}

  ngOnInit() {
    this.pramsId = this.route.snapshot.params.id;
    this.mastersuiteDetails = this.route.snapshot.data.details.response;
    this.AuthService.getUserRoleByProject(this.mastersuiteDetails.role); /* Role */
    this.titleService.setTitle("MS | " + this.mastersuiteDetails["name"]);
    this.isAutoRefresh = true;
    this.parallelRun = this.route.snapshot.data['details'].response.parallelRun;
    this.route.queryParams.subscribe((queryParams) => {
      this.resetValue();
      if (queryParams.noSqlId) {
        this.getExecutionResults(queryParams.noSqlId);
      } else {
        this.getMostRecentExecuted(this.pramsId);
      }
    });
  }

  resetValue() {
    this.recentExecution = null;
    this.testSuiteExecDetails = null;
    this.testCaseExecResult = null;
    this.activeIndex = null;
    this.activeindexTC = null;
    this.resultTsuiteExec = null;
  }

  getExecutionResults(noSqlId: any) {
    const stopwatch = interval(this.autoRefreshInterval * 1000);

    this.MasterSuiteService.getMasterSuiteResultByExecutionId(noSqlId).subscribe((data) => {
      if (data.code === 200) {
        this.recentExecution = data.response;
        this.getResultTSuite(this.recentExecution.execution.executedTaskId, null, null);
        if (!data.response.execution.executionCompleted && !this.autoExecuteCounter) {
          this.autoExecuteCounter = stopwatch.subscribe((x) => {
            if (this.isAutoRefresh) {
              this.getExecutionResults(noSqlId);
            }
          });
        }
        if (this.recentExecution.execution.executionCompleted) {
          if (this.autoExecuteCounter) this.autoExecuteCounter.unsubscribe();
          this.autoExecuteCounter = null;
        }
      }
    });
  }

  getMostRecentExecuted(pramsId: number) {
    this.MasterSuiteService.getMostRecentExec(pramsId).subscribe((data) => {
      if (data.code === 200) {
        this.recentExecution = data.response;
        this.getResultTSuite(this.recentExecution.execution.executedTaskId, null, null);
        this.getMasterSuiteExecResults();
      } else {
        this.Tostr.info(data.message);
      }
    });
  }

  getResultTSuite(noSqlId: string, pageNo?: number, size?: number) {
    let page = pageNo - 1 || this.currentPage - 1;
    const numResults = size || this.perPageData;
    if (page < 0) {
      page = 0;
    }

    this.MasterSuiteService.getResultTSuite(noSqlId, page, numResults).subscribe((data) => {
      if (data.code === 200) {
        this.testSuiteExecDetails = data.response;
        if (!this.activeIndex) {
          this.activeIndex = this.testSuiteExecDetails.testSuites[0].id;
        }
        this.readTestsuiteExecution(this.activeIndex);
      } else {
        this.Tostr.error(data.message);
      }
    });
  }

  getMasterSuiteExecResults() {
    const stopWatch = interval(this.autoRefreshInterval * 1000);
    if (!this.recentExecution.execution.executionCompleted && this.isAutoRefresh) {
      this.autoRefreshCounter = stopWatch.subscribe(() => {
        if (this.recentExecution.execution.executionCompleted) {
          this.autoRefreshCounter.unsubscribe();
        }
        this.MasterSuiteService.getMostRecentExec(this.pramsId).subscribe((data) => {
          if (data.code === 200) {
            this.recentExecution = data.response;
            this.getResultTSuite(this.recentExecution.execution.executedTaskId, null, null);
          }
        });
      });
    }
  }

  readTestsuiteExecution(noSqlId: any) {
    this.showTestsuiteResult = false;
    this.activeIndex = noSqlId;
    this.TestSuiteService.readTestcasesFromNoSql(noSqlId).subscribe((data) => {
      if (data.code === 200) {
        this.resultTsuiteExec = data.response;
        if (this.resultTsuiteExec.testSuiteExecutions != null) {
          this.activeindexTC = this.resultTsuiteExec.testSuiteExecutions[0].noSqlId ?? null;
          this.readTestcaseExecution(this.activeindexTC);
        }
      } else {
        this.Tostr.error(data.message);
      }
    });
  }

  readTestcaseExecution(noSqlId: string) {
    this.showTestsuiteResult = false;
    this.TestcaseService.readEndpointsFromNoSql(noSqlId).subscribe((data) => {
      if (data.code === 200) {
        this.testCaseExecResult = data.response;
      } else {
        this.Tostr.error(data.message);
      }
    });
  }

  autoRefreshClick() {
    if (this.autoRefreshCounter) {
      this.autoRefreshCounter.unsubscribe();
    }
    if (this.autoExecuteCounter) {
      this.autoExecuteCounter.unsubscribe();
    }
    if (this.isAutoRefresh) {
      this.getMasterSuiteExecResults();
    }
  }

  stopMastersuiteExec(executionId: string) {
    this.isAutoRefresh = false;
    this.TestcaseService.stopCurrentExecService(executionId).subscribe((data) => {
      if (data.code === 200) {
        this.Tostr.success(data.message);
        this.getMostRecentExecuted(this.pramsId);
      } else {
        this.Tostr.error(data.message);
      }
    });
  }

  formatChildEntity(child) {
    let entity = child;
    if (child) {
      entity = {
        count: child.length,
        testCases: child,
      };
    }
    return entity;
  }

  onSizeChange(pageSize: number) {
    this.getResultTSuite(this.recentExecution.execution.executedTaskId, null, pageSize);
  }

  onPageChange(page: number) {
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.getResultTSuite(this.recentExecution.execution.executedTaskId, page);
    }
  }

  projectConfigWebTool($event) {
    this.projectConfiguration = $event;
  }

  ngOnDestroy() {
    if (this.autoRefreshCounter) {
      this.autoRefreshCounter.unsubscribe();
    }
    if (this.autoExecuteCounter) {
      this.autoExecuteCounter.unsubscribe();
    }
  }
}
